export const en = {
    'be-sure-no-error': "You don't have permission to view this page",
    title: 'Page unavailable'
};
